import React, { useContext } from "react";
import styled from "styled-components";
import { MiniStoreThemeContext } from "../../../MiniStoreContexts/MiniStoreThemeContext";
import heroImage from "../../../Images/ms_hero_default.png"; // Default fallback image
// import { Link } from "react-router-dom";
// import sampleHeroImage from "../../../Images/sampleHeroImg.png";

const HeroComponent = () => {
  const { theme } = useContext(MiniStoreThemeContext);
  // console.log("inside hero component", theme);
  const merchantLogoSrc = theme?.logoUrl ? theme?.logoUrl : "";
  const heroImgSrc = theme?.heroImgUrl ? theme.heroImgUrl : heroImage;

  return (
    <HeroSection theme={theme} data-bg={heroImgSrc}>
      {theme?.name && (
        <>
          <Overlay />
          <HeroContent>
            <Logo src={merchantLogoSrc} alt="Logo" />
            <Title theme={theme}>Welcome to {theme?.name}</Title>
          </HeroContent>
        </>
      )}
    </HeroSection>
  );
};

export default HeroComponent;

const HeroSection = styled.section`
  position: relative;
  width: 100%;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 0.15rem;
  color: ${({ theme }) => theme.textColor.primary};
  background: url(${(props) => props["data-bg"]}) center/cover no-repeat;
  @media only screen and (max-width: 768px) {
    max-height: 250px;
  }
`;

const Overlay = styled.div`
  border-radius: 0.15rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  padding: 20px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // height: inherit;
`;
const Logo = styled.img`
  width: calc(30% - 40px);
  height: auto;
  max-height: -webkit-fill-available;
  min-width: 100px;
  object-fit: contain;
  border-radius: 0.15rem;
`;
const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  font-family: "Outfit", sans-serif;
  color: ${({ theme }) => theme.primaryColor.primary};
  margin-top: 10px;
  height: auto;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.15rem;
  padding: 1.5rem;
  width: calc(70% - 40px);
  background: rgba(0, 0, 0, 0.5);
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: center;
  overflow: hidden;
  @media only screen and (max-width: 768px) {
    font-size: 20px;
    margin-top: 0;
  }
`;
